import { createRouter, createWebHistory } from "vue-router";
import Home from "./pages/TheHome.vue";
// import BaseDetail from "./components/BaseDetail.vue";
// ##### Starters
import StartersIndex from "./pages/starters/StartersIndex.vue";
import ChickenStarters from "./pages/starters/ChickenStarters.vue";
import MuttonStarters from "./pages/starters/MuttonStarters.vue";
import FishStarters from "./pages/starters/FishStarters.vue";
import VegStarters from "./pages/starters/VegStarters.vue";
// ############################################
// ##### Main Course
import MainCourseIndex from "./pages/MainCourse/MainCourseIndex.vue";
import ChickenMainCourse from "./pages/MainCourse/ChickenMainCourse.vue";
import MuttonMainCourse from "./pages/MainCourse/MuttonMainCourse.vue";
import RotiMainCourse from "./pages/MainCourse/RotiMainCourse";
import RiceMainCourse from "./pages/MainCourse/RiceMainCourse.vue";
import VegMainCourse from "./pages/MainCourse/VegMainCourse.vue";
// ############################################
// ##### SweetsAndDrinks
import SweetsAndDrinksIndex from "./pages/SweetsAndDrinks/SweetsAndDrinksIndex.vue";
// import TheDrinks from "./pages/SweetsAndDrinks/[DEP]TheDrinks.vue";
// import TheSweets from "./pages/SweetsAndDrinks/[DEP]TheSweets.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/starters",
      name: "starters",
      component: StartersIndex,
      children: [
        {
          path: "chicken",
          name: "chicken-starters",
          component: ChickenStarters,
        },
        {
          path: "mutton",
          name: "mutton-starters",
          component: MuttonStarters,
        },
        {
          path: "fish",
          name: "fish-starters",
          component: FishStarters,
        },
        {
          path: "veg",
          name: "veg-starters",
          component: VegStarters,
        },
      ],
    },

    {
      path: "/main-course",
      name: "main-course",
      component: MainCourseIndex,
      children: [
        {
          path: "chicken",
          name: "chicken-main-course",
          component: ChickenMainCourse,
        },
        {
          path: "mutton",
          name: "mutton-main-course",
          component: MuttonMainCourse,
        },
        {
          path: "veg",
          name: "veg-main-course",
          component: VegMainCourse,
        },
        {
          path: "roti",
          name: "roti-main-course",
          component: RotiMainCourse,
        },
        {
          path: "rice",
          name: "rice-main-course",
          component: RiceMainCourse,
        },
      ],
    },
    {
      path: "/sweets-and-drinks",
      name: "sweets-and-drinks",
      component: SweetsAndDrinksIndex,
      // children: [
      //   {
      //     path: "drinks",
      //     name: "drinks",
      //     component: TheDrinks,
      //   },
      //   {
      //     path: "sweets",
      //     name: "sweets",
      //     component: TheSweets,
      //   },
      // ],
    },
  ],
});

export default router;
